import { DashboardV2Dto } from "../../dtos/DashboardV2Dto";
import { ApiResult, apiWrapperWithError } from "./ApiUtils";

export const getDashboardTimeline = async (fy: string): Promise<ApiResult<DashboardV2Dto> | null> => {
    return apiWrapperWithError<DashboardV2Dto>(`api/dashboard-timeline/${encodeURIComponent(fy)}`, 'GET', `fetching dashboard timeline for ${fy}`);
};
